import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { Divider, Stack, Typography } from "@mui/material";
import PatientList from "../patients/PatientList";

const PatientAssistantHomeSidebar = () => {
    return (
        <Stack spacing={2}>
            <Stack spacing={0.5}>
                <Typography variant="h6" fontWeight="bold">Assistente AI</Typography>
                <Typography variant="body2" sx={{ opacity: 0.72 }}>
                    Seleziona un paziente per aprire il suo assistente AI dedicato.
                </Typography>
            </Stack>

            <Divider />

            <Stack spacing={1}>
                <Typography variant="subtitle1" fontWeight="bold">Pazienti</Typography>
                <PatientList getPatientLink={(item) => `/patient/${item.id}/assistant`} />
            </Stack>

            <Divider />

            <Stack direction="row" spacing={1} alignItems="center" sx={{ opacity: 0.72 }}>
                <AutoAwesomeOutlinedIcon fontSize="small" />
                <Typography variant="body2">
                    Apri un paziente per configurare file, analisi e funzioni extra.
                </Typography>
            </Stack>
        </Stack>
    );
};

export default PatientAssistantHomeSidebar;
